import { render, staticRenderFns } from "./WeeklyAgendaView.vue?vue&type=template&id=3e96ac4c&"
import script from "./WeeklyAgendaView.vue?vue&type=script&lang=js&"
export * from "./WeeklyAgendaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports